import { motion } from "framer-motion";
import { Zap } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { ABOUT_PILLARS, CODE_IMAGE, PERTH_IMAGE } from "../data/content";

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="relative py-28 lg:py-36 overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <SectionHeading
              testId="about-heading"
              eyebrow="Why Hylyte"
              title="Everything you need to be great is already inside your business"
              description="Hylyte Digital is a one-stop shop. Your brand, your company, your website and everything around it. Stop waiting for someone to light your fire — Hylyte Digital is your match."
            />
            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-5">
              {ABOUT_PILLARS.map((pillar, i) => (
                <motion.div
                  key={pillar.title}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-40px" }}
                  transition={{ duration: 0.5, delay: i * 0.06, ease: "easeOut" }}
                  className="border-l-2 border-signal/50 pl-4"
                >
                  <h3 className="font-display text-base font-semibold text-white">{pillar.title}</h3>
                  <p className="mt-1 text-sm text-muted leading-relaxed">{pillar.description}</p>
                </motion.div>
              ))}
            </div>
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            className="relative"
          >
            <div className="relative rounded-2xl overflow-hidden border border-white/10">
              <img src={CODE_IMAGE} alt="Code on a developer screen" className="w-full h-[420px] object-cover" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/30 to-transparent" />
              <div className="absolute bottom-5 left-5 right-5 glass rounded-xl p-4 flex items-center gap-4">
                <img src={PERTH_IMAGE} alt="Perth city skyline at night" className="w-16 h-16 rounded-lg object-cover border border-white/10" loading="lazy" />
                <div>
                  <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-signal">Based in Malaga, WA</p>
                  <p className="font-display text-white font-semibold">Serving Perth, Australia-wide &amp; online everywhere</p>
                </div>
              </div>
            </div>
            <div className="absolute -top-5 -right-5 glass rounded-xl px-5 py-3 flex items-center gap-2.5 neon-glow">
              <Zap size={16} className="text-signal" />
              <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-white">100% Australian made</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
